import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const SubscribeService = {
  async getSubscribers(filters, page = 1, perPage = 10) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('payments/v1/buyService/recurrent/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createManualPayment(recurentId) {
    const res = await axios.post(
      `payments/v1/buyService/recurrent/manual/${recurentId}/`
    );

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },
};
